export const genderTypes = {
    1: "male",
    2: "female",
    9: "all",
}